import {
  quoteServiceLineChangeReviewSchema,
  type QuoteServiceLineChangeReview,
} from './quoteReviewContract';
const PRESENTER = 'confirmation.presenters.editQuoteServiceLine';
export function parseQuoteServiceLineReview(
  params: Record<string, unknown>,
  presenter?: string,
  tool?: string
):
  | { kind: 'absent' }
  | { kind: 'invalid' }
  | { kind: 'review'; review: QuoteServiceLineChangeReview } {
  const expected = presenter === PRESENTER || tool === 'edit_quote_service_line';
  if (!('quoteServiceLineChangeReview' in params)) return { kind: expected ? 'invalid' : 'absent' };
  const parsed = quoteServiceLineChangeReviewSchema.safeParse(params.quoteServiceLineChangeReview);
  if (!expected || presenter !== PRESENTER || !parsed.success) return { kind: 'invalid' };
  const r = parsed.data;
  if (
    r.quote.status !== 'quote' ||
    r.quote.isDisputed ||
    !r.quote.services.some((s) => s.bookingServiceId === r.bookingServiceId) ||
    r.result.pricing.netSubtotalCents + r.result.pricing.taxCents !==
      r.result.pricing.grossTotalCents ||
    r.changes.some(
      (c) =>
        !r.ops.some(
          (op) =>
            ('lineId' in op
              ? op.lineId
              : 'newLineId' in op
                ? op.newLineId
                : op.bookingServiceId) === c.lineId
        )
    )
  )
    return { kind: 'invalid' };
  return { kind: 'review', review: r };
}
